import Landing from "./landing/landing";

const routes = [
  { path: "/", component: Landing }
];

export default routes;
